
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.37.29a1.49 1.49 0 0 0-2.09.34L7.25 20.2l-4.69-4.69a1.5 1.5 0 0 0-2.12 2.12l5.93 5.94a1.53 1.53 0 0 0 2.28-.19l15.07-21a1.49 1.49 0 0 0-.35-2.09Z"}})])
          )
        }
      }
    